import axios from 'axios';

import { headers, ledgerServiceUrl } from '../../config';

function search(search) {
    return axios.get(`${ledgerServiceUrl}/years-search`, { headers: headers(), params: { search } });
}

export default {
    search
}